var _PlayArrow, _Pause, _Replay, _Forward, _Volume, _VolumeOff;
import { useCallback, useEffect } from 'react';
import { cn } from '@crehana/compass.ui/utils';
import Forward10 from '@crehana/icons/Forward10';
import Pause from '@crehana/icons/Pause';
import PlayArrow from '@crehana/icons/PlayArrow';
import Replay10 from '@crehana/icons/Replay10';
import Volume from '@crehana/icons/Volume';
import VolumeOff from '@crehana/icons/VolumeOff';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors, KEY_NAMES } from '@crehana/ui';
import { isTouchDevice } from '@crehana/utils';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled, { keyframes } from 'styled-components';
import { usePlaybackContext } from "../context/Playback";
import { useUIContext } from "../context/UI";
import { useVisibleActionContext } from "../context/VisibleAction";
import OverlayMessage from "./OverlayMessage";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var showIconAnim = /*#__PURE__*/keyframes(["\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(1.5);\n    opacity: 0;\n  }\n"]);
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-18nvgo0-0"
})(["\n  & > svg {\n    animation: 0.5s ", " forwards;\n  }\n  & > span {\n    animation: 0.5s ", " forwards;\n  }\n"], showIconAnim, showIconAnim);
var white = colors.white;
var Overlay = function Overlay() {
  var _useVisibleActionCont = useVisibleActionContext(),
    currentAction = _useVisibleActionCont.currentAction;
  var _usePlaybackContext = usePlaybackContext(),
    togglePlay = _usePlaybackContext.togglePlay,
    visibleSkip = _usePlaybackContext.visibleSkip,
    currentSpeed = _usePlaybackContext.currentSpeed,
    isPlaying = _usePlaybackContext.isPlaying,
    isStarted = _usePlaybackContext.isStarted,
    isEnded = _usePlaybackContext.isEnded;
  var _useUIContext = useUIContext(),
    visibleUi = _useUIContext.visibleUi,
    showUi = _useUIContext.showUi,
    pausedOverlay = _useUIContext.pausedOverlay,
    endOverlay = _useUIContext.endOverlay,
    onEndOverlayVisibilityChange = _useUIContext.onEndOverlayVisibilityChange;
  var onTouchOrClick = useCallback(function () {
    if (isTouchDevice() && !visibleUi && !visibleSkip) {
      showUi();
    } else {
      togglePlay();
    }
  }, [visibleUi, visibleSkip, showUi, togglePlay]);
  var onClick = useCallback(function (event) {
    event.stopPropagation();
    onTouchOrClick();
  }, [onTouchOrClick]);
  var onKeyDown = useCallback(function (event) {
    if (event.key === KEY_NAMES.SPACE) {
      event.stopPropagation();
      onTouchOrClick();
    }
  }, [onTouchOrClick]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    if (onEndOverlayVisibilityChange) {
      var endOverlayIsVisible = !!endOverlay && isEnded;
      onEndOverlayVisibilityChange(endOverlayIsVisible);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!endOverlay, isEnded]);
  var renderIcon = useCallback(function () {
    if (currentAction === 'play') {
      return _PlayArrow || (_PlayArrow = /*#__PURE__*/_jsx(PlayArrow, {
        size: 42,
        color: white,
        className: "playarrow-icon"
      }));
    }
    if (currentAction === 'pause') {
      return _Pause || (_Pause = /*#__PURE__*/_jsx(Pause, {
        size: 42,
        color: white,
        className: "pause-icon"
      }));
    }
    if (currentAction === 'backward') {
      return _Replay || (_Replay = /*#__PURE__*/_jsx(Replay10, {
        size: 42,
        color: white,
        className: "replay10-icon"
      }));
    }
    if (currentAction === 'forward') {
      return _Forward || (_Forward = /*#__PURE__*/_jsx(Forward10, {
        size: 42,
        color: white,
        className: "forward10-icon"
      }));
    }
    if (currentAction === 'speed') {
      return /*#__PURE__*/_jsx("span", {
        className: "text-white font-h2",
        children: currentSpeed.label
      });
    }
    if (currentAction === 'volume') {
      return _Volume || (_Volume = /*#__PURE__*/_jsx(Volume, {
        size: 42,
        color: white,
        className: "volume-icon"
      }));
    }
    if (currentAction === 'mute') {
      return _VolumeOff || (_VolumeOff = /*#__PURE__*/_jsx(VolumeOff, {
        size: 42,
        color: white,
        className: "volumeoff-icon"
      }));
    }
    return null;
  }, [currentAction, currentSpeed.label]);
  return /*#__PURE__*/_jsxs(Wrapper, {
    className: cn('cp-overlay tw-absolute tw-flex tw-items-center tw-justify-center tw-inset-0', visibleUi || visibleSkip ? 'tw-cursor-pointer tw-z-3' : 'tw-cursor-none tw-z-0'),
    "data-testid": "cp-overlay",
    onClick: onClick,
    onKeyDown: onKeyDown,
    children: [pausedOverlay && /*#__PURE__*/_jsx(OverlayMessage, {
      overlay: pausedOverlay,
      visible: isStarted && !isPlaying && !isEnded
    }), endOverlay && /*#__PURE__*/_jsx(OverlayMessage, {
      overlay: endOverlay,
      visible: isEnded,
      showOnMobile: true
    }), renderIcon()]
  });
};
export default Overlay;